"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DarkTheme = void 0;
var _colorTokens = _interopRequireDefault(require("./color-tokens"));
var _colors = _interopRequireDefault(require("../../tokens/colors"));
var _colorSemanticTokens = _interopRequireDefault(require("./color-semantic-tokens"));
var _colorComponentTokens = _interopRequireDefault(require("./color-component-tokens"));
var _borders = _interopRequireDefault(require("./borders"));
var _lighting = _interopRequireDefault(require("../shared/lighting"));
var _typography = _interopRequireDefault(require("../shared/typography"));
var _animation = _interopRequireDefault(require("../shared/animation"));
var _breakpoints = _interopRequireDefault(require("../shared/breakpoints"));
var _grid = _interopRequireDefault(require("../shared/grid"));
var _mediaQuery = _interopRequireDefault(require("../shared/media-query"));
var _sizing = _interopRequireDefault(require("../shared/sizing"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

const DarkTheme = exports.DarkTheme = {
  name: 'dark-theme',
  colors: {
    ..._colorTokens.default,
    ..._colors.default,
    ...(0, _colorComponentTokens.default)(),
    ...(0, _colorSemanticTokens.default)()
  },
  animation: _animation.default,
  breakpoints: _breakpoints.default,
  borders: _borders.default,
  direction: 'auto',
  grid: _grid.default,
  lighting: _lighting.default,
  mediaQuery: _mediaQuery.default,
  sizing: _sizing.default,
  typography: _typography.default,
  // TODO(#2318) Remove it in the next v11 major version.
  // Do not use.
  zIndex: {
    modal: 2000
  }
};